import './App.css';
import Dictionary from "./dictionary";

export default function App() {
  return (
    <div className="App">
      <div className="container">
         <header className="App-header">
          <h1>Dictionary</h1>
      </header>
      <main>
        <Dictionary defaultKeyword={""} />
      </main>
      <footer className="App-footer">
      <small>  Coded by
               Shaniyah Palmer
              and is 
            <a href="https://github.com/SEP1905">
              open-sourced
           </a>
          </small>
      </footer>
      </div>
    </div>
  );
}
